import React from "react";

const DocumentsBigIcon = () => {
  return (
    <svg
      width="22"
      height="28"
      viewBox="0 0 22 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.625 0.5H3.125C2.42881 0.5 1.76113 0.784463 1.26884 1.29081C0.776562 1.79716 0.5 2.48392 0.5 3.2V24.8C0.5 25.5161 0.776562 26.2028 1.26884 26.7092C1.76113 27.2155 2.42881 27.5 3.125 27.5H18.875C19.5712 27.5 20.2389 27.2155 20.7312 26.7092C21.2234 26.2028 21.5 25.5161 21.5 24.8V8.6L13.625 0.5ZM12.3125 9.94998V3.19998L18.875 9.94998H12.3125ZM15.043 20.6H17.55C18.0196 20.6 18.4 20.9692 18.4 21.425C18.4 21.8808 18.0196 22.25 17.55 22.25H15.043C14.1691 22.25 13.3818 21.7787 12.9903 21.0197C12.8336 20.7145 12.5605 20.6835 12.45 20.6835C12.3395 20.6835 12.0664 20.7139 11.9177 21.0027L11.5102 21.7937C11.4397 21.9307 11.3312 22.0459 11.1969 22.1265C11.0626 22.207 10.9078 22.2496 10.75 22.2495C10.7298 22.2495 10.7102 22.2484 10.6894 22.2469C10.3468 22.2237 10.0519 22.002 9.9441 21.6854L9.05 19.0835L8.48635 20.7273C8.17344 21.6379 7.29741 22.25 6.30822 22.25H5.65C5.18038 22.25 4.8 21.8808 4.8 21.425C4.8 20.9692 5.18038 20.6 5.65 20.6H6.30822C6.56482 20.6 6.79219 20.4412 6.87347 20.205L7.83982 17.3876C8.01513 16.8818 8.50069 16.5415 9.05 16.5415C9.59932 16.5415 10.0849 16.8813 10.2597 17.3876L10.997 19.5347C12.0473 18.6999 13.8684 19.0345 14.5033 20.2648C14.6106 20.4742 14.8199 20.6 15.043 20.6Z"
        fill="#30323A"
      />
    </svg>
  );
};

export default DocumentsBigIcon;
